import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { useSelector } from "react-redux";
import { useLazyLoadQuery } from "react-relay";
import { DashboardScreen_Query } from "@generated/DashboardScreen_Query.graphql";
import { ChangeEmailDialog } from "../../infecto-lms-webapp/components/change-email-dialog";
import { UserStatusMessage } from "../../infecto-lms-webapp/components/UserStatusMessage.component";
import { usePageTitle } from "../../infecto-lms-webapp/hooks/usePageTitle";
import { useTypedDispatch } from "../../infecto-lms-webapp/redux/redux-store";
import {
	addHiddenUserMessage,
	selectHiddenUserMessages,
} from "../../infecto-lms-webapp/redux/slices/hidden-user-messages.slice";
import { CarouselsTabsComponent } from "../components/dashboard/CarouselsTabs.component";
import { UserStartedNotBlockedNodesComponent } from "../components/dashboard/UserStartedNotBlockedNodes.component";
import { HideableMessage } from "../components/HideableMessage";
import { PageMainText } from "../components/PageTitleText";
import { CarouselContainer } from "../containers/Carousel.container";
import { PageDefaultContainer } from "../containers/PageDefaultContainer";
import { WideContainerWithTopBar } from "../containers/WideContainerWithTopBar.container";

const DASHBOARD_QUERY = graphql`
	query DashboardScreen_Query {
		Viewer {
			Auth {
				currentUser {
					user {
						extension(userExtensionKind: InfectopharmUserExtension) {
							... on InfectopharmUserExtension {
								salutation
								title
								lastName
								firstName
								efnNumber
								country
								isEmailUpdateRequired
							}
						}
						...UserStatusMessage_UserFragment
					}
				}
			}
		}
	}
`;

export function DashboardScreen() {
	usePageTitle("Dashboard");
	const dispatch = useTypedDispatch();
	const hiddenUserMessages = useSelector(selectHiddenUserMessages);

	const query = useLazyLoadQuery<DashboardScreen_Query>(DASHBOARD_QUERY, {});
	//eslint-disable-next-line @typescript-eslint/no-explicit-any
	const extractSalutation = (userData: any) => {
		let salutation = userData?.salutation || "";
		const title = userData?.title || "";

		switch (salutation) {
			case "Mr":
				salutation = "Herr";
				break;
			case "Mrs":
				salutation = "Frau";
				break;
			case "Unknown":
				salutation = "";
				break;
			case "Divers":
				salutation = "";
				break;
		}

		const lastName = userData?.lastName || "";
		if (salutation === "Frau" || salutation === "Herr") {
			return [salutation, lastName].filter((c) => c.length > 0).join(" ");
		} else {
			return [title, lastName].filter((c) => c.length > 0).join(" ");
		}
	};
	const currentUser = query.Viewer.Auth.currentUser?.user;

	return (
		<PageDefaultContainer collapsed={false} screenName="dashboard">
			<WideContainerWithTopBar>
				{currentUser?.extension?.country == "Oesterreich" && (
					<div>
						{!hiddenUserMessages.includes("salutationAustria") ? (
							<HideableMessage
								onClick={() => dispatch(addHiddenUserMessage("salutationAustria"))}
								content={
									<div>
										Willkommen auf der Lernplattform von InfectoPharm Deutschland. Sie können alle
										Bereiche dieser Website nutzen. Wenn Sie zertifizierte Module abschließen, haben
										Sie nach Bestehen die Möglichkeit, sich ein Zertifikat herunterzuladen und
										dieses bei der Österreichischen Ärztekammer einzureichen. Eine automatische
										Meldung der Punkte findet nicht statt.
									</div>
								}
							/>
						) : null}
					</div>
				)}
				{}
				<UserStatusMessage userFragment={currentUser!} />
				<PageMainText>
					Hallo {extractSalutation(currentUser?.extension)}, was möchten Sie heute lernen?
				</PageMainText>
				<p className="text-base">Beenden Sie Ihre begonnen Module</p>
				<CarouselContainer>
					<UserStartedNotBlockedNodesComponent />
					<CarouselsTabsComponent />
				</CarouselContainer>
			</WideContainerWithTopBar>
			{currentUser?.extension?.isEmailUpdateRequired ? (
				<ChangeEmailDialog
					isEmailRequired={currentUser.extension?.isEmailUpdateRequired || false}
				/>
			) : null}
		</PageDefaultContainer>
	);
}
